import store from './../store';
import errors from './errors';

export function httpRequestInterceptor(config) {
	const headers = config.headers;
	const token = store.getters['user/token'];
	if (token) {
		headers.common.Authorization = `Bearer ${token}`;
		store.dispatch('toggleLoading', true);
	} else {
		this.$router.push('login');
	}
	return config;
}

export function httpResponseSuccessInterceptor(response) {
	store.dispatch('toggleLoading', false);
	return response;
}

export function httpResponseInterceptor(error) {
	store.dispatch('toggleLoading', false);
	let text = 'Su sesión expiró.';
	const status = error.response ? error.response.status : null;
	const loginRoute = { name: 'login' };
	if (status === 401) {
		this.$router.push(loginRoute);
	} else if (status === 400) {
		text = errors(error.response);
	} else if (status === 402) {
		const data = error.response.data || {};
		text = data.message || 'Tu plan está vencido. Renuévalo para seguir usando el sistema.';
	} else if (status === 403) {
		text = 'No tiene suficientes permisos para realizar ésta acción';
	} else if (status === 500) {
		text = 'No se logró completar la acción, intente de nuevo.';
	}
	store.dispatch('showSnackBar', { text, color: 'error' });
	return Promise.reject(error.response);
}



// WEBPACK FOOTER //
// ./src/http/index.js